'use strict';

var React = require('react');
var BusinessHoursSelector = require('./BusinessHoursSelector.js');
require('prop-types');
var Grid = require('../../node_modules/@material-ui/core/esm/Grid/Grid.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var DAYS_IN_A_WEEK = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
function EditBusinessHoursForm(_ref) {
  var businessHours = _ref.businessHours,
      _onChange = _ref.onChange;
  return React__default["default"].createElement(Grid["default"], {
    container: true,
    justify: "center"
  }, DAYS_IN_A_WEEK.map(function (dayString, index) {
    return React__default["default"].createElement(Grid["default"], {
      item: true,
      xs: 12,
      sm: 10,
      key: index
    }, React__default["default"].createElement(BusinessHoursSelector, {
      dayOfWeek: dayString,
      singleDay: businessHours[dayString],
      onChange: function onChange(dayOfWeek, startTime, endTime) {
        _onChange(dayOfWeek, startTime, endTime);
      }
    }));
  }));
}
EditBusinessHoursForm.defaultProps = {
  businessHours: {},
  onChange: function onChange() {}
};

module.exports = EditBusinessHoursForm;
